// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Qh4k","obliqueLineWrap":"membershipbadge_obliqueLineWrap__ggeG2","obliqueLine":"membershipbadge_obliqueLine__29_om"};